// eslint-disable-next-line import/no-extraneous-dependencies
import isChromatic from 'chromatic/isChromatic';

const ignoreInChromatic = () =>
  isChromatic() ? { 'data-chromatic': 'ignore' } : {};

export default ignoreInChromatic;
